import { SpaceFeature, UnitInterface } from "@swivl-mono/types";

// grabbed all of this from fms.model.ts
const fmsParams = {
  smallMaxSize: 50,
  mediumMaxSize: 150,
  largeMaxSize: 300,
  actionButton: "Reserve Now",
  sizeSmallDescription: "Similar in size to a walk-in closet. Holds the contents of a studio apartment.",
  sizeMediumDescription: "Similar in size to a small bedroom. Holds the contents of a typical garage.",
  sizeLargeDescription: "Similar in size to a 1 to 1.5 car garage. Holds the contents of a 3-4 bedroom house",
  sizeExtraLargeDescription: "You have a lot of stuff! These units have plenty of room for your whole house!",
  sizeParkingDescription: "Each spot varies, but sizing ranges from a small utility trailer, vehicle, or camper, to a large Class A / Motorhome.",
  showPrice: true,
  showFloor: true,
};

export function getDescriptionAndImageForUnit(space: UnitInterface | undefined) {
  if (!space) {
    return { imageURL: "", description: "" };
  }

  let imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png";
  let description = fmsParams.sizeSmallDescription;
  if (space?.features?.includes(SpaceFeature.PARKING)) {
    imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-parking%402x.png";
    description = fmsParams.sizeParkingDescription;
  } else if (space?.width && space?.length) {
    const sqft = space.width * space.length;
    if (sqft <= fmsParams.smallMaxSize) {
      imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png";
      description = fmsParams.sizeSmallDescription;
    } else if (sqft > fmsParams.smallMaxSize && sqft <= fmsParams.mediumMaxSize) {
      imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-medium%402x.png";
      description = fmsParams.sizeMediumDescription;
    } else if (sqft > fmsParams.mediumMaxSize && sqft <= fmsParams.largeMaxSize) {
      imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-large%402x.png";
      description = fmsParams.sizeLargeDescription;
    } else if (sqft > fmsParams.largeMaxSize) {
      imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-extra-large%402x.png";
      description = fmsParams.sizeExtraLargeDescription;
    } else {
      imageURL = "https://swivl-cdn.s3.us-west-1.amazonaws.com/unit-small%402x.png";
      description = fmsParams.sizeSmallDescription;
    }
  }

  if (space?.features?.includes(SpaceFeature.COMMERCIAL_WAREHOUSE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-commercial-warehouse%402x.png";
  }
  if (space?.features?.includes(SpaceFeature.LOCKER)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-locker%402x.png";
  }
  if (space?.features?.includes(SpaceFeature.OFFICE_SPACE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-office-space%402x.png";
  }

  if (space?.type?.toLowerCase().includes("parking")) {
    description = fmsParams.sizeParkingDescription;

    if (space?.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-car%402x.png";
    } else if (space?.features?.includes(SpaceFeature.ENCLOSED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-car%402x.png";
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-car%402x.png";
    }
  }

  if (space?.features?.includes(SpaceFeature.RV_PARKING)) {
    if (space?.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-rv%402x.png";
    } else if (space?.features?.includes(SpaceFeature.ENCLOSED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-rv%402x.png";
    } else if (space?.features?.includes(SpaceFeature.PAVED) && space.features?.includes(SpaceFeature.PULL_THRU)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-pullthru-paved-rv%402x.png";
    } else if (space?.features?.includes(SpaceFeature.UNPAVED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-unpaved-rv%402x.png";
    } else if (space?.features?.includes(SpaceFeature.PAVED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-paved-rv%402x.png";
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-rv%402x.png";
    }
  }

  if (space?.features?.includes(SpaceFeature.BOAT_PARKING)) {
    if (space?.features?.includes(SpaceFeature.COVERED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-covered-boat%402x.png";
    } else if (space?.features?.includes(SpaceFeature.ENCLOSED)) {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-enclosed-boat%402x.png";
    } else {
      imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-parking-uncovered-boat%402x.png";
    }
  }

  if (space?.features?.includes(SpaceFeature.SAFETY_DEPOSIT_BOX)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-security-deposit-box%402x.png";
  }
  if (space?.features?.includes(SpaceFeature.WINE_STORAGE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-wine%402x.png";
  }
  if (space?.features?.includes(SpaceFeature.GUN_STORAGE)) {
    imageURL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/unit-gun.png";
  }

  return { imageURL: imageURL, description: description };
}
